import React, {useState} from "react";
import {DndProvider} from "react-dnd";
import {HTML5Backend} from "react-dnd-html5-backend";
import {ReactFlowProvider} from "react-flow-renderer";

import TableWithMaps from "./TableWithMaps";
import DFDCanvas from "./processingAndAnanysis/dfd/DFDCanvas";
import {DataSourceProvider} from "./processingAndAnanysis/dfd/hooks/useContextDataSource";


export default function () {
    const [isRenderMode, setIsRenderMode] = useState(false);
    const [serverMapInfo, setServerMapInfo] = useState([]);
    const [shouldShowServerMapTable, setShouldShowServerMapTable] = useState(true);

    const switchTableShowing = () => setShouldShowServerMapTable(!shouldShowServerMapTable);

    return <div className="main-project-analytics-container" id="main-project-analytics-container">
        {
            shouldShowServerMapTable &&
            <TableWithMaps serverMapInfo={serverMapInfo} setServerMapInfo={setServerMapInfo}/>
        }
        {!isRenderMode && <input
            type="button"
            className="project-analytics-table-showing-handler"
            value={shouldShowServerMapTable ? "<" : ">"}
            onClick={switchTableShowing}
        />}
        <ReactFlowProvider>
            <DndProvider backend={HTML5Backend}>
                <DataSourceProvider>
                    <DFDCanvas
                        handleServerMapTableShowing={setShouldShowServerMapTable}
                        serverMapInfo={serverMapInfo}
                        isRenderMode={isRenderMode}
                        setIsRenderMode={setIsRenderMode}
                        shouldShowServerMapTable={shouldShowServerMapTable}
                    />
                </DataSourceProvider>
            </DndProvider>
        </ReactFlowProvider>
    </div>;
}
